import HandymanIcon from '@mui/icons-material/Handyman';
import { SegnalazioniService } from '../../../services/controllers/segnalazioni-services/SegnalazioniService';
import StorBeFeParser from '../../utils/storBeFeParser';
import SegnalazioneType from '../../variables/SegnalazioniType';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField } from "@mui/material";
import { useState } from 'react';
import CONSTANTS from '../../utils/Constants';

const customStyle = {
    color: "#004D99",
    width: 30,
    height: 30,
};

const CustomRectifyIconButton = (props : any) => {

    const [open, setOpen] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(checkUser());
    const [justification, setJust] = useState<String>();
    const segnalazioniService : SegnalazioniService = new SegnalazioniService()

    const handleCancel = () => {
        let resetJust = ''
        setJust(resetJust)
        setOpen(false)
    }

    function checkUser(){
        if(props.user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole)){
          return false
        }
        else
          return true
      }

    function setJustification(event : any){
        if(props.user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole))
            setJust(event.target.value)
        else{
            if(event && event.target && event.target.value!==''){
                setButtonDisabled(false)
            }
            else
                setButtonDisabled(true)
            setJust(event.target.value)
        }
    }


    async function goModifyPage(idSegnalazione : string) {
        sessionStorage.setItem('idSegnalazione', idSegnalazione)
        getStorByIDEffect()
    }
    
    async function getStorByIDEffect(){
            const response = await segnalazioniService.getRettifica(sessionStorage?.getItem('idSegnalazione') || '');
            if (response){
                response.updateReason = justification;
                const parsedSegnalazione = await StorBeFeParser.parseBetoFe(response)
                sessionStorage.setItem('idSegnalazioneCreazione', parsedSegnalazione?.systemInformations?.id || '')
                if(parsedSegnalazione && parsedSegnalazione?.systemInformations?.type){
                    switch(parsedSegnalazione?.systemInformations?.type){
                        case 'STOR':
                            sessionStorage.setItem('segnalazioneType', SegnalazioneType.STOR)
                            break;
                        case 'Market Observation':
                            sessionStorage.setItem('segnalazioneType', SegnalazioneType.MARKET_OBSERVATION)
                            break;
                        default :
                            sessionStorage.setItem('segnalazioneType', SegnalazioneType.ALTRO)
                    }
                }
                sessionStorage.setItem('newSegnalazione', JSON.stringify(parsedSegnalazione))
                sessionStorage.setItem('SegnalazioneInviataAzione', 'rettifica')
                window.location.href = '/stor-fe/stor/create'
            }
        }
    

        return <div className="d-inline w-25"> 
        <IconButton aria-label="rettifica" style={customStyle} title={props.title} onClick={() => {setOpen(true)}}> 
            <HandymanIcon />
        </IconButton>
        <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        >
        <DialogTitle id="alert-dialog-title">
          Giustificazione
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Inserisci una giustificazione per l'integrazione
          </DialogContentText>
          <TextField
            autoFocus
            rows={5}
            multiline
            margin = "dense"
            id = "justification"
            label = "Giustificazione"
            type = "text"
            onChange={(event => {setJustification(event)})}
            defaultValue={justification}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Annulla</Button>
          <Button onClick={() => goModifyPage(props.idSegnalazione)} autoFocus disabled = {buttonDisabled}>
            Continua
          </Button>
        </DialogActions>
      </Dialog>
    </div>
}

export default CustomRectifyIconButton;